import { trackingAxios } from '../config/api/tracking'
import { AssignTemplate } from '../interfaces/templates'
export interface Template {
    id:number,
    name: string
    description: string
}

export interface Group {
    group_id: number
    chutes: number[]
}

export interface TemplateForm {
    name: string,
    groups: Group[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const create = async (template: Template) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.post(
            'templates',
            { name: template.name },
            { headers }
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const getTemplates = async (page: number, template: string) => {
    const params = {
        name: template,
    }
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.get(`templates?page=${page}`, {
            params,
            headers,
        })
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const getTemplatesRules = async () => {
  try {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    }
    const response = await trackingAxios.get(`templates/groups`, {
      headers,
    })
    return response.data
  } catch (e) {
    // Sentry.Native.captureException(e)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    throw e.response.data
  }
}
export const getTemplatesRulesGroup = async () => {
    try {
      const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      }
      const response = await trackingAxios.get(`templates/groups`, {
        headers,
      })
      return response.data
    } catch (e) {
      // Sentry.Native.captureException(e)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      throw e.response.data
    }
  }
  
export const getTemplateDetail = async (id: number) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.get(`templates/${id}`, { headers })
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const getTemplateRules = async (template: number) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.get(
            `templates/${template}/groups`,
            { headers }
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const addChute = async (template: string, assign: AssignTemplate) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.post(
            `templates/${template}/associate`,
            assign,
            { headers }
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const deletePattern = async (template: number) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.delete(
            `templates/${template}`,
            { headers }
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const getAllRules = async (defaultValue = false, active = true) => {
    const params = {
        default: defaultValue,
        active: active
    }
  try {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    }
    const response = await trackingAxios.get(`groups/all`, {
        params,
        headers,
    })
    return response.data
  } catch (e) {
    // Sentry.Native.captureException(e)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    throw e.response.data
  }
}

export const getAllChutes = async (type: string) => {
    const params = {
        type: type,
    }
  try {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    }
    const response = await trackingAxios.get(`configurations/chutes`, {
        params,
        headers,
    })
    return response.data
  } catch (e) {
    // Sentry.Native.captureException(e)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    throw e.response.data
  }
}

export const createPattern = async (template: TemplateForm) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.post(
            'templates',
            { ...template },
            { headers }
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const updateTemplate = async (templateId: number, template: TemplateForm) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }
        const response = await trackingAxios.patch(
            `templates/${templateId}`,
            { ...template },
            { headers }
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data as OrderError
    }
}